<div class="container">
    <div>
        <h1>Broken Link</h1>
        <a href="/login">go back</a>
    </div>
</div>